<script setup lang="ts">
    import type { RouteRecordRaw } from "vue-router"

    interface CurrentMenuItem {
        meta?: { subIndex?: number }
    }

    defineProps<{
        items: RouteRecordRaw[]
        currentItem: CurrentMenuItem
        isCollapse: boolean
    }>()

    const emits = defineEmits(["update:is-collapse"])
</script>

<template>
    <el-menu
        :default-active="String(currentItem.meta?.subIndex ?? '')"
        style="height: calc(100vh - 60px)"
        :collapse="isCollapse"
        @open="() => {}"
        @close="() => {}"
    >
        <el-menu-item class="base-arrow-wrapper" index="arrow-wrapper" @click="() => {}">
            <el-tooltip effect="dark" content="收合選單" placement="right">
                <BaseSvgIcon
                    :class="[isCollapse ? 'transition' : '', 'base-arrow', 'outline-none']"
                    name="sidebar-open"
                    class="!-ml-3"
                    data-test="collapse-button"
                    @click="emits('update:is-collapse', !isCollapse)"
                />
            </el-tooltip>
        </el-menu-item>

        <div v-if="!isCollapse">
            <BaseNavbarMenuItems :items="items"></BaseNavbarMenuItems>
        </div>
    </el-menu>
</template>

<style lang="scss" scoped>
    .base-arrow-wrapper {
        justify-content: flex-start;
        cursor: auto;
        &:hover {
            background-color: $fill-blank;
        }
    }

    .base-arrow {
        cursor: pointer;
    }

    .transition {
        transform: rotate(180deg);
    }
</style>
